import { JSX } from "react";

type Props = {
    onClick?: () => void;
    variant?: "normal" | "destructive" | undefined;
    children: JSX.Element | JSX.Element[] | Array<JSX.Element | string> | string | undefined;
    disabled?: boolean;
    otherClasses?: string;
}

export default function Button(props: Props) {
    let bgColor = "bg-blue-300";

    switch(props?.variant ?? "normal") {
        case "normal": 
            if (!(props.disabled ?? false))
                bgColor = "bg-blue-400";
            else
                bgColor = "bg-blue-200";
            break;
        case "destructive":
            if (!(props.disabled ?? false))
                bgColor = "bg-red-400"
            else
                bgColor = "bg-red-200"

        default:
            break;
    }
    return (
        <div className={`${bgColor} p-2 rounded-lg w-fit h-fit text-white ${props.otherClasses ?? ""} ${(props.disabled??false) ? "" : "hover:cursor-pointer"}`} onClick={() => { if (props.onClick && !(props.disabled ?? false)) props.onClick(); }}>{props.children}</div>
    )
}